import { BrowserRouter, Routes, Route } from "react-router-dom";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.min.js';
import './App.css';
import './components/header.css';
// import '../node_modules/bootstrap/dist/js/bootstrap.js';
import Home from "./pages/home";
import Categories from "./pages/categories";
import ProductDetails from "./pages/product-details";
import NoPage from "./pages/404";
import Dashboard from "./pages/dashboard";
import Login from "./pages/login";
import Signin from "./pages/signin";
import AddProduct from "./pages/add-item"

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path="/" index element={<Home />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/product-details" element={<ProductDetails />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/add-item" element={<AddProduct />} />
          <Route path="*" element={<NoPage />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
